module.exports = __webpack_public_path__ + "static/media/6780.78482827.jpg";